import { useState } from "react";
import "./Tooltip.scss";

const Tooltip = ({ children, content, disabled = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!content || disabled) {
    return children;
  }

  return (
    <div
      className="tooltip_wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="tooltip_content">
          <div className="tooltip_arrow" />
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
